import { SignInButton } from "@clerk/clerk-react";
import { Unauthenticated } from "convex/react";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useAuth } from "@clerk/clerk-react";

export const Route = createFileRoute("/login")({
  component: LoginPage,
});

function LoginPage() {
  const { isSignedIn } = useAuth();

  if (isSignedIn) {
    return <Navigate to="/app/search" />;
  }

  return (
    <Unauthenticated>
      <div className="min-h-screen flex flex-col items-center justify-center bg-background">
        <div className="w-full max-w-sm space-y-8">
          <div className="flex flex-col items-center">
            <img 
              src="/logo.svg" 
              alt="Logo" 
              className="h-16 w-auto mb-12"
            />
            
            <SignInButton mode="modal">
              <button className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-primary-foreground bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary">
                Login / Sign up
              </button>
            </SignInButton>
          </div>
        </div>
      </div>
    </Unauthenticated>
  );
}
